export default {"appid":"__UNI__D486520"}